import React from 'react';
import { Linkedin, Facebook, Instagram, Youtube, Music } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-gradient-to-br from-indigo-900 via-purple-800 to-pink-800 text-white py-12 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="text-center space-y-6">
          <h3 className="text-2xl font-serif font-bold">Oluwatobi I. Abiola-Adeyemo</h3>
          <p className="text-purple-200">Strategic Program Leader | Business Consultant | Author | Speaker</p>
          <div className="flex justify-center gap-4">
            <a 
              href="https://www.linkedin.com/in/oluwatobi-ibukun-abiola-mba-392b49171"
              target="_blank"
              rel="noopener noreferrer"
              className="w-10 h-10 bg-gradient-to-br from-teal-400 to-teal-600 hover:from-teal-500 hover:to-teal-700 rounded-lg flex items-center justify-center transition-all hover:scale-110"
            >
              <Linkedin className="h-4 w-4" />
            </a>
            <a 
              href="https://www.facebook.com/share/1CAKQF5u6t/"
              target="_blank"
              rel="noopener noreferrer"
              className="w-10 h-10 bg-gradient-to-br from-blue-400 to-blue-600 hover:from-blue-500 hover:to-blue-700 rounded-lg flex items-center justify-center transition-all hover:scale-110"
            >
              <Facebook className="h-4 w-4" />
            </a>
            <a 
              href="https://www.instagram.com/ibukunabiola"
              target="_blank"
              rel="noopener noreferrer"
              className="w-10 h-10 bg-gradient-to-br from-pink-400 to-purple-600 hover:from-pink-500 hover:to-purple-700 rounded-lg flex items-center justify-center transition-all hover:scale-110"
            >
              <Instagram className="h-4 w-4" />
            </a>
            <a 
              href="https://youtube.com/@theatjpodcast"
              target="_blank"
              rel="noopener noreferrer"
              className="w-10 h-10 bg-gradient-to-br from-red-400 to-red-600 hover:from-red-500 hover:to-red-700 rounded-lg flex items-center justify-center transition-all hover:scale-110"
            >
              <Youtube className="h-4 w-4" />
            </a>
            <a 
              href="https://share.google/qWXeGeOpjaJxHp8Ww"
              target="_blank"
              rel="noopener noreferrer"
              className="w-10 h-10 bg-gradient-to-br from-green-400 to-green-600 hover:from-green-500 hover:to-green-700 rounded-lg flex items-center justify-center transition-all hover:scale-110"
            >
              <Music className="h-4 w-4" />
            </a>
          </div>
          <div className="border-t border-purple-700 pt-8 mt-8">
            <p className="text-purple-300 text-sm">
              © {new Date().getFullYear()} Oluwatobi I. Abiola-Adeyemo. All rights reserved.
            </p>
            <div className="mt-4">
              <a 
                href="/admin" 
                className="text-purple-400 text-xs hover:text-purple-200 transition-colors"
              >
                Admin
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;